<template>
  <div v-if="items && items.links.length">
    <v-container class="pt-3 pb-0" v-if="items.heading" >
      <h4 class="title grey--text text--darken-1 pt-0 pb-3" v-html="items.heading" />
    </v-container>
    <v-list dense>
      <v-list-tile
        ripple
        router
        v-for="(link, index) in items.links"
        :key="index"
        :to="`${pageTopSlug}/${link.slug}`">
        <v-list-tile-content>
          <v-list-tile-title v-html="link.title" />
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>
<script>
  export default {
    name: 'SidebarLinks',
    data () {
      return {
        items: this.$store.getters.sidebar.items.pages,
        pageTopSlug: this.$store.state.pageTopSlug
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SidebarLinks.vue